<template>
  <div :style="{margin:0,padding:0}">
    <div class="loading-container" v-if="!user.status || user.status === 'loading'">
      <LoadingSpinner class="loading-spinner" />
    </div>
    <div id="app" v-if="user.status === 'loaded' || user.status === 'unauthorized' || user.status === 'uploading'" >
      <Header v-if="!$route.meta.guest && !$route.meta.requiresCompilation" />
      <router-view/>
      <Footer v-if="!$route.meta.guest && !$route.meta.requiresCompilation && $route.path !== '/admin-page' " />
    </div>
  </div>
</template>

<script>
import { Header, Footer } from './components/';
import LoadingSpinner from './components/elements/LoadingSpinner';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  data() {
    return {}
  },
  components: {
    Header, Footer, LoadingSpinner
  },

  computed: {
    ...mapGetters(['user'])
  },
}
</script>


<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding:0;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-stroke: 0.45px rgba(0, 0, 0, 0.1);
  background: transparent;
  animation: app .4s ease-out;
}
@keyframes app {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.9;
  }
   
  100% {
    opacity: 1;
  }
}
</style>
